import React from 'react'

import { Spinner } from '@acorns/web-components'

import Button from 'components/Button'
import { getRemoteStrings } from 'components/HOCs/withRemoteStrings/withRemoteStrings'
import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { TestIDs } from 'test/utils/testIds'

import { enhance } from './enhance'
import {
  ButtonContainer,
  Container,
  Detail,
  IraSubtext,
  IraTitle,
  RecommendationText,
} from './styled-components'

const LATER_STRINGS = {
  Traditional: 'traditional',
  SimplifiedEmployeePension: 'sep',
  Roth: 'roth',
}
const OpenAccountButton = withClickTrack<any, any>(TRACKER_IDS.LATER_RECOMMENDATION.OPEN_BUTTON)(
  Button,
)

export const LaterIraRecommendation: React.SFC<any> = props => (
  <>
    <Nav back={true} />
    <Layout header={props.headerText} text={props.subHeader}>
      <Container>
        {props.creatingAccount ? (
          <Spinner />
        ) : (
          <>
            <IraTitle data-testid={TestIDs.LATER_IRA_RECOMMENDATION.TITLE}>
              Learn about your {props.recommended} IRA
            </IraTitle>
            <RecommendationText>
              <Detail data-testid={TestIDs.LATER_IRA_RECOMMENDATION.TEXT}>
                {getRemoteStrings(
                  'later_ira_account_type_' + LATER_STRINGS[props.recommended] + '_markdown',
                  '',
                  'laterOnboarding',
                )}
              </Detail>
            </RecommendationText>
            <Separator />
            <ButtonContainer>
              <IraSubtext data-testid={TestIDs.LATER_IRA_RECOMMENDATION.SUBTEXT}>
                {getRemoteStrings(
                  'later_ira_info_limits',
                  'Contributions to all IRA’s should not exceed $6,000',
                  'laterOnboarding',
                )}
              </IraSubtext>
              <OpenAccountButton
                onPress={props.handleNextPress}
                data-testid={TestIDs.LATER_IRA_RECOMMENDATION.SUBMIT_CTA}
              >
                Open My IRA
              </OpenAccountButton>
            </ButtonContainer>
          </>
        )}
      </Container>
    </Layout>
  </>
)

export default enhance(LaterIraRecommendation)
